import { useQuery } from 'react-query'
import apiRoutes from '../../api/apiRoutes'
import ApiCall from '../../api/network'

const fetchRecentAlarms = async (junctionId) => {
  return await ApiCall.any(apiRoutes.GetRecentAlarms, {}, { jid: junctionId })
}

export const useRecentAlarms = (junctionId) => {
  return useQuery(
    ['recent-alarms', junctionId],
    () => fetchRecentAlarms(junctionId),
    {
      enabled: junctionId !== undefined,
    }
  )
}
